import { gql } from '@apollo/client';

export const LIST_AD_TYPES = gql`
  query List {
    listAdType {
      list {
        id
        type
      }
    }
  }
`;
